import {getPortal} from "../index"

// SELECTORS
export const getPortalMe = (state) => getPortal(state).me

// REDUCER
export default (
  state = {id: "1", name: "Kayla Logan", position: "Associate"},
  action
) => {
  switch (action.type) {
    default:
      return state
  }
}
